import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';
import {useAppState} from "@stores/AppStateContext";

import {DeleteWithNameConfirm} from '../components/DeleteWithNameConfirm/DeleteWithNameConfirm';
import {deleteTaskListUnit} from '../../../../actions/taskList/deleteTaskListUnit';
import {TaskListUnitDeleteProps} from '../modal-names';

export const DeleteTaskListUnit = observer((
    {
        taskListUnit,
    }: TaskListUnitDeleteProps
) => {
    const appState = useAppState();
    const handleConfirm = async () => {
        const serviceRegistry = appState.getServiceRegistry();
        await deleteTaskListUnit(
            serviceRegistry.getDataClientService(),
            serviceRegistry.getAuthService(),
            taskListUnit
        );
        appState.setModal(null);
    };

    return (
        <DeleteWithNameConfirm
            header={intl.get('TaskListUnitDelete.title').d('Delete location')}
            confirmText={intl.get('TaskListUnitDelete.button').d('Delete Location')}
            expectedValue={taskListUnit.name}
            onConfirm={handleConfirm}
            onClose={() => appState.setModal(null)}
            text={
                <>
                    <div>{intl.get('TaskListUnitDelete.text.firstPart', {locationName: taskListUnit.name}).d('Deleting the location <b>“{locationName}”</b> will permanently remove along with their completion history and reports. This action <b>cannot be undone.</b>')}</div>
                    <div style={{marginBlockStart: 'var(--lgc-space-300)'}}>{intl.get('TaskListUnitDelete.text.secondPart').d('To confirm, please enter the name of the Location.')}</div>
                </>
            }
        />
    );
});
